import script from './component-lib.esm17.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "fbWrapperRef",
    staticClass: "fb-video-wrapper"
  }, [_c('div', {
    staticClass: "fb-video",
    attrs: {
      "data-href": _vm.id,
      "data-width": "auto",
      "data-show-text": "false",
      "data-allowfullscreen": "true",
      "data-autoplay": "false"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-16434b82_0", {
    source: ".fb-video-wrapper iframe{position:absolute!important;height:100%!important;width:100%!important;top:0;left:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var FacebookVideo = __vue_component__;
export { FacebookVideo as default };